import { routes } from '../../constants';
import image403 from '../../images/errorPages/403.svg';
import { ResetErrorLink } from '../layouts/ResetErrorLink';

export const Forbidden = () => (
    <div className="container-error">
        <div className="content-error">
            <div className="error-type-block">
                <img src={image403} width="530" height="300" alt="403" />
            </div>
            <h1>Error: Access Forbidden</h1>
            <p className="error-description">
                Sorry, access to this resource is denied.
            </p>
            <p className="error-links">
                Either check the URL, <ResetErrorLink to={routes.root}>go home</ResetErrorLink>, or feel free to <a href={`mailto:${process.env.REACT_APP_SALES_EMAIL}`}>report the issue</a>.
            </p>
        </div>
    </div>
);
